import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { saveReturnPath } from '../helpers/returnPath';

const LoginLayout: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isLoginRoute = location.pathname === '/login' ||
                      location.pathname === '/login/callback' ||
                      location.pathname === '/not-authorized';

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !isLoginRoute) {
      saveReturnPath(location.pathname + location.search);
      navigate('/login');
    }
  }, [isLoading, isAuthenticated, isLoginRoute, navigate, location.pathname, location.search]);

  if (!isLoginRoute) {
    return null;
  }
  


  return <Outlet />;
};

export default LoginLayout;
